export default __webpack_public_path__ + "static/media/CNo.21-1.5af9973e.jpg";